<template>
  <div :class="topClassName">
    <app-navigation></app-navigation>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  import AppNavigation from './shared/AppNavigation.vue';
  
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';


  export default {
    data: () => ({
        fullPage: true,
        colorless: true
    }),
    components: {
      'app-navigation': AppNavigation,
      'loading': Loading
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading
      },
      isColorless() {
        return this.colorless
      },
      levelLabel() {
        let userLevel = this.$store.getters.getAuthUser ? this.$store.getters.getAuthUser.level.toLowerCase() : 'n5'
        if (this.$route.name == 'top') {
          return userLevel;
        } else if (this.$route.name == 'top.level') {
          return (this.$route.params.level != undefined) ? this.$route.params.level : 'n4';
        } else {
          const currentSection = this.$store.getters.section_data
          if(currentSection && (currentSection.level == 'N4' || currentSection.level == 'N5')) {
            return currentSection.level.toLowerCase();
          } else if(currentSection && (currentSection.level == 'n3' || currentSection.level == 'N3')) {
            return 'n3';
          } else if(currentSection && (currentSection.level == 'n2' || currentSection.level == 'N2')) {
            return 'n2';
          } else {
            return '';
          }
        }
      },
      topClassName() {
        let className = !this.colorless ? 'bg-colored' : ''
        let className1 = ''
        if(this.levelLabel == 'n3') {
          className1 = 'n3'
        } else if(this.levelLabel == 'n2') {
          className1 = 'n2'
        }
        if(this.$store.getters.useLevel) {
          if(this.$store.getters.useLevel != 'N3' && this.$store.getters.useLevel != 'N2') {
            className1 = ''
          }
        }
        let className2 = this.$store.getters.selectedLanguage ? 'lang-' + this.$store.getters.selectedLanguage.key : 'lang-ja'
        return className + ' ' + className1 + ' ' + className2
      },
    },
    watch: {
      $route(to, from) {
        if((!/^(apps|lesson|top|login|^profile\.)/.test(to.name) && to.name != 'inquiry.message')
              || (to.name == 'top' || to.name == 'top.level' || to.name == 'lesson.category' || to.name == 'profile.situation' || to.name == 'profile.situation.level'
              || to.name == 'profile.situation.detail')) {
          this.colorless = false
        } else {
          this.colorless = true
        }
      }
    },
    created() {
      let currentHistory = this.$router.history.current
      
      if((!/^(apps|lesson|top|login|^profile\.)/.test(currentHistory.name) && currentHistory.name != 'inquiry.message')
        || (currentHistory.name == 'top' || currentHistory.name == 'top.level' || currentHistory.name == 'lesson.category' || currentHistory.name == 'profile.situation'
        || currentHistory.name == 'profile.situation.level'|| currentHistory.name == 'profile.situation.detail')) {
        this.colorless = false
      } else {
        this.colorless = true
      }
    }
  }
</script>
